export default "__VITE_ASSET__Bx$BvYZM__"